import { login, logout, getUserInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import {getCompanyInfos,getSaleInfos,getSaleOrgsBySaler} from "../../api/login";
import {queryOrg} from "../../api/system/organization";

const user = {
  state: {
    token: getToken(),
    //当前登录用户
    currentUser: null,
    //登录用户所属财务组织
    companyOrgs: null,
    //当前选择公司index
    index:null,
    //登录用户所属销售组织，客户和业务员可以下单购买的销售组织
    saleOrgs:null,
    //当前选择销售组织index
    sIndex:null,
    //客户提货组织
    customerStorageOrg:null,
    //客户财务组织
    customerCompany:null
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.currentUser = user
    },
    SET_COMPANYORGS: (state, orgs) => {
      state.companyOrgs = orgs
    },
    SET_SALEORGS: (state , orgs) => {
      state.saleOrgs = orgs
    },
    SET_INDEX:(state , index) => {
      state.index = index
    },
    SET_S_INDEX:(state ,index) => {
      state.sIndex = index
    },
    SET_CUSTOMER_STORAGE_ORG:(state ,org) => {
      state.customerStorageOrg = org
    },
    SET_CUSTOMER_COMPANY:(state , org) => {
      state.customerCompany = org
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          setToken(res.data.tokenValue);
          commit('SET_TOKEN', res.data.tokenValue);
          resolve();
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          commit('SET_USER', res.data);
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户所属财务组织信息
    GetCompanyInfo({ commit }){
      return new Promise( (resolve , reject) => {
        getCompanyInfos().then(res => {
          if(res.code === 200){
            commit('SET_COMPANYORGS' , res.data);
            commit('SET_INDEX' , 0);
          }
          resolve();
        }).catch(error => {
          reject(error);
        })
      })
    },

    //获取客户所属销售组织信息
    GetSaleInfo({ commit,dispatch }){
      return new Promise((resolve , reject) =>{
        getSaleInfos().then(res =>{
          if(res.code === 200){
            commit('SET_SALEORGS' , res.data);
            commit('SET_S_INDEX' , 0);

          }
          resolve(res);
        })
      }).catch( error => {
        reject(error);
      })
    },
    //获取业务员所属销售组织信息
    GetSaleInfoBySaler({ commit,dispatch }){
      return new Promise((resolve , reject) =>{
        getSaleOrgsBySaler().then(res =>{
          if(res.code === 200){
            commit('SET_SALEORGS' , res.data);
            commit('SET_S_INDEX' , 0);
          }
          resolve(res);
        })
      }).catch( error => {
        reject(error);
      })
    },


    //获取客户发货组织（库存组织）与财务组织信息
    GetCustomerOrgs({commit , state}){
      let _this = this;
      return new Promise((resolve , reject) => {
        let params = {};
        if(state.sIndex !== null && state.saleOrgs !== null && state.saleOrgs.length > 0){
          params.id = state.saleOrgs[state.sIndex].id;
        }

        queryOrg(params).then(res =>{
          if(res.success === true){
            //todo 通过data获取子节点
            commit('SET_CUSTOMER_STORAGE_ORG' , res.data.orgUnitRelation.storageOrgUnitName);
            commit('SET_CUSTOMER_COMPANY' , res.data.orgUnitRelation.financeOrgUnitName);
          }
          resolve();
        }).catch( error =>{
          reject(error);
        })
      })
    },

    // 退出系统
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', '');
          //清空缓存的登录用户信息
          commit('SET_USER', null);
          // commit('SET_ROLES', [])
          // commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user
